import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconCrop: React.FC<IconProps> = ({ width = 16, height = 16, color = 'white' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 640 640"
        fill={color}
    >
        <path d="M192 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v256c0 35.3 28.7 64 64 64h208v-64H192V96zm256 448c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V192c0-35.3-28.7-64-64-64H240v64h208v352z" />
    </svg>
);

export default IconCrop;
